import { combineReducers } from 'redux';
import purchaseOrders from './purchaseOrders';
import suppliers from './suppliers';
import settingsByWarehouse from './settingsByWarehouse';

export interface IInventoryEnquiryReorderingState {
  [name: string]: any;
}

const ReorderingReducer = combineReducers<IInventoryEnquiryReorderingState>({
  purchaseOrders,
  suppliers,
  settingsByWarehouse
});

export default ReorderingReducer;
